import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'

import CpuConfig from './CpuConfig'

import styles from './styles.scss'

class NotebookCpu extends Component {

  render() {
    const {
      revision,
      currentRevision
    } = this.props
    return (
      <Flex styleName="CpuWrapper">
        <CpuConfig
          values={revision[currentRevision].data.defaultCpu[0]}
        />
      </Flex>
    )
  }
}

export default CSSModules(NotebookCpu, styles)
